import { createLeadInstance } from './axios/leadAxiosInstance';
import env from '@/config/env';

export const leadInstance = createLeadInstance(env.USER_API_URL);

export const leadStorageInstance = createLeadInstance(env.STORAGE_API_URL);
